export const BODY_CLASS =
    "text-base text-Text_Black  font-medium inline-flex justify-start  p-3";
export const TOAST_CONTAINER_CLASS =
    "  !bottom-0 !left-0 !right-0  border-2 !rounded border-Text_Gray  !w-full !flex !justify-center !items-center  bg-white !mx-4 !mb-2 ";
export const BOTTOM_CENTER = "bottom-center";
